let activeResourceId = ''

export function setActiveResourceId(resourceId) {
  activeResourceId = String(resourceId || '')
}

export function getActiveResourceId() {
  return activeResourceId
}

export function clearActiveResourceId() {
  activeResourceId = ''
}
